import React from 'react';
import AddCadec from './AddCadec';

export default function EditCadec(props) {
  return <AddCadec goTo={props.goTo} isEditing />;
}
